import React from 'react';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => {
    const { text01 } = theme.palette;
    return {
        badge: {
            background: 'rgba(0, 0, 0, 0.7)',
            borderRadius: '5px',
            color: text01,
            fontSize: '14px',
            maxWidth: '50%',
            overflow: 'hidden',
            padding: '2px 16px',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    };
});
/**
 * Component that displays a name badge.
 *
 * @param {Props} props - The props of the component.
 * @returns {ReactElement}
 */
const DisplayNameBadge = ({ name }) => {
    const { classes } = useStyles();
    // PMCODE
    const state = APP.store.getState(), hasPatientLink = state['features/datisalute'].patientLink != null && state['features/datisalute'].patientLink !== "";
    return (React.createElement("div", { className: classes.badge, style: { marginBottom: (hasPatientLink ? '40px' : '0') } }, name));
};
export default DisplayNameBadge;
